import { Stack, styled } from '@mui/material';

import { theme } from '@/shared/design-system';

export const VerificationContent = styled(Stack)({
  flexDirection: 'column',
  gap: `${theme.spacing[24]}px`,
});

export const MethodActions = styled(Stack)({
  flexDirection: 'column',
  gap: `${theme.spacing[12]}px`,
});

export const OtpBlock = styled(Stack)({
  alignItems: 'flex-start',
  flexDirection: 'column',
  gap: `${theme.spacing[12]}px`,
});

export const PendingStatus = styled(Stack)({
  alignItems: 'center',
  color: theme.colors.text.secondary,
  gap: `${theme.spacing[12]}px`,
  textAlign: 'center',
});
